import { Component, computed, inject, input, signal } from '@angular/core';

import { CmsTab, CmsTabsCollection } from '@fcom/core-api';
import { KeyCodes, isKeyboardEvent } from '@fcom/core/utils/keycodes';
import { ButtonTheme } from '@fcom/ui-components/components/buttons/button/enums';
import { GtmService } from '@fcom/common/gtm/services/gtm.service';
import { ElementActions, ElementTypes, GaContext } from '@fcom/common/interfaces/gtm.interface';

@Component({
  selector: 'cms-content-switcher-tabs',
  templateUrl: './cms-content-switcher-tabs.component.html',
  styleUrls: ['./cms-content-switcher-tabs.component.scss'],
  standalone: false,
})
export class CmsContentSwitcherTabsComponent {
  private gtmService = inject(GtmService);

  content = input.required<CmsTabsCollection>();

  readonly ButtonTheme = ButtonTheme;

  private readonly selectedTab = signal<CmsTab>(undefined);

  readonly currentTab = computed(() => {
    return this.selectedTab() ?? this.content().tabs[0];
  });

  selectTab(tab: CmsTab): void {
    this.selectedTab.set(tab);

    this.trackElement(tab.content.segment);
  }

  handleKeyPress(event: KeyboardEvent, tab: HTMLButtonElement): void {
    const element: HTMLElement = this.getElement(event, tab);
    const buttonElement: HTMLButtonElement = element?.querySelector('button');
    if (buttonElement) {
      buttonElement.click();
      buttonElement.focus();
    }
  }

  private getElement(event: KeyboardEvent, tab: HTMLButtonElement): HTMLElement {
    const lastChild = tab.parentElement.parentElement.children[tab.parentElement.parentElement.children.length - 1];
    const firstChild = tab.parentElement.parentElement.children[0];

    if (isKeyboardEvent(event, KeyCodes.HOME)) {
      return firstChild as HTMLElement;
    } else if (isKeyboardEvent(event, KeyCodes.END)) {
      return lastChild as HTMLElement;
    } else if (isKeyboardEvent(event, KeyCodes.RIGHT)) {
      return (tab.parentElement.nextElementSibling || firstChild) as HTMLElement;
    } else if (isKeyboardEvent(event, KeyCodes.LEFT)) {
      return (tab.parentElement.previousElementSibling || lastChild) as HTMLElement;
    } else {
      return undefined;
    }
  }

  private trackElement(label: string) {
    this.gtmService.trackElement(
      `tab-${label}`,
      GaContext.CONTENT,
      ElementTypes.BUTTON,
      undefined,
      ElementActions.CLICK
    );
  }
}
